/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


   
 jQuery(document).ready(function () {
    //detect ios
    function iOS() {
        return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
    if (iOS()) {
        $(document).find('body').addClass('device-ios');
    }
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $('body').addClass('device-ios');
    }
    if($('.accordion-text').hasClass('faq-content')) {
        $('.accordion-text .faq-left .accordion-list:first-child').addClass('open');
        $('.accordion-text .faq-left .accordion-list:first-child').find('.content').slideDown();
    } else {
        $('.accordion-text .accordion-list:first-child').addClass('open');
        $('.accordion-text .accordion-list:first-child').find('.content').slideDown();
    }
    $(document).on('click', '.accordion-list', function() {    
        if($(this).parents('.faq-content').length) {
            if ($(this).hasClass('open')) {
                $(this).find('.content').slideUp();
                $(this).removeClass('open');
            } else {
                $(this).parents('.faq-content').find('.content').slideUp();
                $(this).parents('.faq-content').find('.accordion-list').removeClass('open');
                $(this).find('.content').slideDown();
                $(this).addClass('open');        
            }
        } else {
            if ($(this).hasClass('open')) {
                $(this).find('.content').slideUp();
                $(this).removeClass('open');
            } else {
                $(this).parent().find('.content').slideUp();
                $(this).parent().find('.accordion-list').removeClass('open');
                $(this).find('.content').slideDown();
                $(this).addClass('open');        
            }
        }
        
    });
    $('.CollectionList').slick({
      dots: true,
      infinite: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 6000,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: true,
      centerPadding: '16px',
      slidesToScroll: 1,
    });
    $('.template-product .testi-content').slick({
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        centerMode: false,
        slidesToScroll: 1,
    });
    $('.TestimonialLists').slick({
        dots: false,
        infinite: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        centerMode: false,
        slidesToScroll: 1,
        draggable: false
    });
   
    $('.TestimonialLists .slick-arrow.arrow-prev').click(function() {
        $('.TestimonialLists .slick-prev.slick-arrow').trigger('click');
    });
    $('.TestimonialLists .slick-arrow.arrow-next').click(function() {
        $('.TestimonialLists .slick-next.slick-arrow').trigger('click');
    });
    $('.use-left .icon-video').on('click', function(){
        $('.product-use .Modal--videoContent').attr('aria-hidden', false);
    });
    $(document).on('click', '.product-use .Modal__Close', function(){
        $('.product-use .Modal--videoContent').attr('aria-hidden', true);
    });
    if ($(window).width() < 813) {
       $('.claims-left .claims-content').slick({
            dots: true,
            infinite: true,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 6000,
            slidesToShow: 1,
            centerMode: false,
            slidesToScroll: 1,
        });
    }
    // Hide header on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.shopify-section--header').outerHeight();

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        
        // Make scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        
        // If scrolled down and past the navbar, add class .nav-up.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('.shopify-section--header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('.shopify-section--header').removeClass('nav-up').addClass('nav-down');
            }
        }
    
        lastScrollTop = st;
    }
    $(window).on('resize', function () {
        if ($(window).width() < 813) {
            if($('.claims-left .claims-content').length) {
                $('.claims-left .claims-content').slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    autoplay: false,
                    autoplaySpeed: 6000,
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1,
                });
            }
        } else {
            if($('.claims-left .claims-content').hasClass('slick-initialized')){
                $('.claims-left .claims-content').slick('unslick');
            }
        }
        if($('.use-product .product-wrapper').length) {
            if ($(window).width() < 1140) {
                $('.use-product .product-wrapper').slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    autoplay: false,
                    autoplaySpeed: 6000,
                    variableWidth: true,
                    centerMode: false,
                    slidesToScroll: 1,
                });
            } else {
                if($('.use-product .product-wrapper').hasClass('slick-initialized')){
                    $('.use-product .product-wrapper').slick('unslick');
                }
            } 
         }
    });
    if ($(window).width() < 1140) {
        $('.use-product .product-wrapper').slick({
            dots: true,
            infinite: true,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 6000,
            variableWidth: true,
            centerMode: false,
            slidesToScroll: 1,
        });
    }
    $('.Collapsible__Inner .use-slider').slick({
        slidesToShow: 1,
        dots: true,
        arrows: false
    });
   /* Click back menu */
    $(document).on('click', '.back-icon', function (e) {
        $(this).parent().prev().attr('aria-expanded', 'false');
        $().parent().css('overflow', 'hidden');
    });
    $(document).on('click', '.show-filter', function (e) {
        $(this).next().slideToggle();
        $(this).toggleClass('open');
    });
    $(document).on('click', '.PageOverlay.is-visible', function (e) {
        $('.Search__Close').trigger("click");
    });
   
    /*ALIGN HEIGHT PRODUCT*/
    function alignHeight(selector, n) {
        var items = jQuery(selector);
        var newArrays = new Array(Math.ceil(items.length / n))
          .fill()
          .map(_ => items.splice(0, n))
  
        $(newArrays).each(function () {
          jQuery(this).css('height', '');
          var minHeight = 0;
          jQuery(this).each(function () {
            if (minHeight < jQuery(this).outerHeight()) {
              minHeight = jQuery(this).outerHeight();
            }
          });
          if (minHeight > 0) {
            jQuery(this).css('height', minHeight);
          }
        });
    }

 
    if ($(window).width() > 1140) { 
        alignHeight ('.ProductItem__Wrapper .ProductItem__Title', 3);
        alignHeight ('.ProductItem__Wrapper .ProductItem__Info', 3);
        alignHeight ('.ProductItem__Wrapper .more-info', 3);
        alignHeight ('.ProductItem__Wrapper .variant-item', 3);
        alignHeight ('.ProductItem__Wrapper .ProductForm__BuyButtons button', 3);
      
    }
    else {
        alignHeight ('.ProductItem__Wrapper .ProductItem__Title', 2);
        alignHeight ('.ProductItem__Wrapper .ProductItem__Info', 2);
        alignHeight ('.ProductItem__Wrapper .more-info', 2);
        alignHeight ('.ProductItem__Wrapper .variant-item', 2);
        alignHeight ('.ProductItem__Wrapper .ProductForm__BuyButtons button', 2);

    }
    
    $(window).on('resize', function () {
        if ($(window).width() > 1140) { 
            alignHeight ('.ProductItem__Wrapper .ProductItem__Title', 3);
            alignHeight ('.ProductItem__Wrapper .ProductItem__Info', 3);
            alignHeight ('.ProductItem__Wrapper .more-info', 3);
            alignHeight ('.ProductItem__Wrapper .variant-item', 3);
            alignHeight ('.ProductItem__Wrapper form', 3);
       
        }
        else {
            alignHeight ('.ProductItem__Wrapper .ProductItem__Title', 2);
            alignHeight ('.ProductItem__Wrapper .ProductItem__Info', 2);
            alignHeight ('.ProductItem__Wrapper .more-info', 2);
            alignHeight ('.ProductItem__Wrapper .variant-item', 2);
            alignHeight ('.ProductItem__Wrapper form', 2);
            alignHeight ('.ProductItem__Wrapper .ProductForm__BuyButtons button', 2);
        }
        
    });

    $('.tips-heading').on('click', function() { 
        if (!$(this).parent().hasClass('open')) {
            $(this).parent().addClass('open');     
            $(this).parent().find('.tips-content').slideDown();
        } else {
            $(this).parent().find('.tips-content').slideUp();
            $(this).parent().removeClass('open');        
        }
    });

    $(document).on('click', '.close-icon', function(e) {
        $(this).parents('.badge').remove();
        $(this).parents('.formula-ingredients').removeClass('active');
        $('body').removeClass('has-popup');
    });


    $(document).on('click', '.select-button', function(e) {
        $(this).addClass('hide');
        $(this).prev().addClass('show');
        $(this).next().removeClass('hide');
    });
    $(document).on('click', '.CollectionToolbar__Item', function(e) {
        $('.PageOverlay').removeClass('is-visible');
    });
    


    $(document).click(function (e){
        // Đối tượng container chứa popup
        var container = $('.formula-ingredients');
        if($(e.target).hasClass('formula-link')) {
            e.preventDefault();
            $('.formula-ingredients').addClass('active');
            $('body').addClass('has-popup');
        } else {
            if (!container.is(e.target) && container.has(e.target).length === 0 && container.hasClass('active')) {
                container.removeClass('active');
                $('body').removeClass('has-popup');
            }
        }
    });
    if ($(window).width() < 813) {
        $('.formula-content .content .part').each(function(){
            if($(this).html().length > 500) {
                $(this).addClass('has-toggle');
                $(this).addClass('accordion-list');
            }
        });
    }
    var headerHeight = $('.Header').height();
    $(".bar-list").on('click', 'a', function (){
        var ele = '.' + $(this).data('ele');
        $('html, body').animate({
            scrollTop: ($(ele).offset().top - headerHeight)
        }, 1000);
    });
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        var heightDifference = 0;
        if($('.section-icon').length) {
            heightDifference = $('.section-icon').offset().top - headerHeight - 10;
        }
        var heightReviews = 0;
        if ($('.okeReviews-widget-holder').length) {
            heightReviews = $('.okeReviews-widget-holder').offset().top - headerHeight - 10;
        }
        var heightClaims = 0;
        if($('.product-claims').length) {
            heightClaims = $('.product-claims').offset().top - headerHeight - 10;
        }
        var heightUse = 0;
        if($('.product-use').length) {
            heightUse = $('.product-use').offset().top - headerHeight - 10;
        }
        var heightFormula = 0;
        if($('.product-formula').length) {
            heightFormula = $('.product-formula').offset().top - headerHeight - 10;
        }
        var heightFaq = 0;
        if($('.product-faq').length) {
            heightFaq = $('.product-faq').offset().top - headerHeight - 10;
        }
        
        if (scroll >= heightClaims) {
            $(".bar-list li").removeClass('active');
            $(".bar-list").find('a[data-ele="product-claims"]').parent().addClass('active');
            if (scroll >= heightUse) {
                $(".bar-list li").removeClass('active');
                $(".bar-list").find('a[data-ele="product-use"]').parent().addClass('active');
                if (scroll >= heightFormula) {
                    $(".bar-list li").removeClass('active');
                    $(".bar-list").find('a[data-ele="product-formula"]').parent().addClass('active');
                    if (scroll >= heightFaq) {
                        $(".bar-list li").removeClass('active');  
                        $(".bar-list").find('a[data-ele="product-faq"]').parent().addClass('active');
                        if (scroll >= heightDifference) {
                            $(".bar-list li").removeClass('active');
                            $(".bar-list").find('a[data-ele="section-icon"]').parent().addClass('active');
                            if (scroll >= heightReviews) {
                                $(".bar-list li").removeClass('active');  
                                $(".bar-list").find('a[data-ele="okeReviews-widget-holder"]').parent().addClass('active');
                            }
                        }
                    }
                    
                }
            }
        }
    });
    //the formula product
    $('.product-formula').find('.initial-content').each(function(index){
        var eleH3 = $(this).find('h3');
        if(eleH3.length > 0) {
            eleH3.attr('data-index', index);
            if( index == 0 ) {
                eleH3.addClass('active');
            }
        }
        $('.formula-heading').append(eleH3);
    });
    // Set height image as same as height of content
    if ($(window).width() > 767){ 
        $('.product-formula').find('.formula-heading').each(function(index){
            var eleH3 = $(this).find('h3');
            var getHeightTabContent = $('.content.active').height();
            var heightFormulaTitle = $('.formula-title').height ();
            var heightTabHeading = $('.formula-heading').height();
            if(eleH3.length == 0) {
                var heightLeftContent = getHeightTabContent + heightFormulaTitle + heightTabHeading + 95;
                $('.formula-right img').height(heightLeftContent);
            }
           else {
            var heightLeftContent = getHeightTabContent + heightFormulaTitle + heightTabHeading + 132;
            $('.formula-right img').height(heightLeftContent);
           }
        });
    }
  
    $(document).on('click', '.product-formula h3', function() {
        var getHeightTabContent;
        var heightImageRight;
        var item = $(this).attr('data-index');
        $('.product-formula h3').removeClass('active');
        $(this).addClass('active');
        $('.product-formula .content').each(function(){
            var index = $(this).attr('data-index');
            if(index == item) {
                $(this).addClass('active');
                getHeightTabContent = $('.content.active').height();
                heightImageRight = $('.formula-right img').height();
                heightFormulaTitle = $('.formula-title').height ();
                heightTabHeading = $('.formula-heading').height();
                var heightLeftContent = getHeightTabContent + heightFormulaTitle + heightTabHeading + 132;
                if ($(window).width() > 767){
                    $('.formula-right img').height(heightLeftContent);
                }
                
            } else {
                $(this).removeClass('active');
            }
        });
    });
    
    $(document).on('click', '.instagenie-overlay', function() {
        $('body').addClass('not-scroll');
    });

    $(document).on('click', '.instagenie-modal-show', function() {
        if(!$(event.target).closest('.instagenie-modal-insta').length && !$(event.target).is('instagenie-modal-insta')) {
            $('.close-button a').trigger('click');
            $('body').removeClass('not-scroll');
        }  
    });
   
    // FAQ page
     $('.faqs-wrapper .sidebar-content li:first-child').addClass("selected");
     $('.faqs-wrapper .sidebar-content li').click(function(){
        // Toggle class selected
         $('.faqs-wrapper .sidebar-content li').removeClass("selected");
         $(this).addClass("selected");
    });

    // Arcodion FAQ
     $('.faqs-wrapper .content h5:first-of-type').addClass('open');
     $('.faqs-wrapper .content h5').on('click', function () {
         if ($(this).hasClass('open')) {
             $(this).next().slideUp(500);
             $(this).removeClass('open');
         } else {
             $('.faqs-wrapper .content h5.open + p').slideUp(500);
             $('.faqs-wrapper .content h5').removeClass('open');

             $(this).next().slideDown(500);
             $(this).addClass('open');
         }
     });

     // Slick about us page
    const doubleImage = $('#double-image')
    
    if( doubleImage.length) {
        doubleImage.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed:6000,
            infinite: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                     breakpoint: 500,
                     settings: 'unslick'
                }
            ]
         });

        $(window).on('resize', function() {
            doubleImage.slick('resize');
        });
        }
});


$(window).on('load resize', function () {
    var vh = window.innerHeight ;
    document.documentElement.style.setProperty('--vhbrower', `${vh}px`);

});

// FAQ
function offsetAnchor(minus) {
    window.scrollTo(window.scrollX, window.scrollY - minus);
}

if($(document).width() < 768) {
    $('.faqs-wrapper .sidebar-content li').click(function(){
        // Close nav when selected item
         $('.faqs-wrapper .sidebar-content .sidebar-heading-mobile + ul').slideUp(500);

        // Change active value heading 
         $('.faqs-wrapper .sidebar-heading-mobile').text($(this).text());
    });

    $('.sidebar-heading-mobile').click(function() {
        $(this).toggleClass('active');
         $('.faqs-wrapper .sidebar-content .sidebar-heading-mobile + ul').slideToggle(500);
    })

     $(document).on('click', 'a[href^="#"]', function (event) {
         // Click events are captured before hashchanges. Timeout
         // causes offsetAnchor to be called after the page jump.
         window.setTimeout(function () {
             offsetAnchor(300);
         }, 600);
     });
}

// if ($(document).width() > 768) {
//     $(document).on('click', 'a[href^="#"]', function (event) {
//         window.setTimeout(function () {
//             offsetAnchor(45);
//         }, 40);
//     });
// }

setTimeout(function(){
  $('.CollectionMain .klaviyo-button-container').css('position','relative');
},200);